module.exports = __webpack_public_path__ + "img/barcode2.eeba25f1.png";